<template>
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content" name="example">
        <div class="imgCarrello">
            <img src="/images/LogoCarrello.png">
        </div>
        <div class="textCarrello">
            <span v-show="this.showText" >
                {{ this.risorse["ConfermaOrdine"] }}
            </span>
            <div class="textDanger" v-show="this.showOrderError">{{ this.orderErrorMsg }}</div>
            <div class="textSuccess" v-show="this.showOrderSuccess">{{ this.risorse["OrdineOk"] }}</div>
        </div>
        <div class="btnContainer">
            <div class="Button CustomColor"><a class="btnCart btnContinue" href="javascript:void(0)" @click="this.closeModal()">{{ this.risorse["Chiudi"] }}</a></div>
            <div v-show="!this.isLoading && !this.submitDisabled" class="Button CustomColor"><a class="btnCart" href="javascript:void(0)" @click="this.submitOrder()" >{{ this.risorse["InviaOrdine"] }}</a></div>
            <div class="loader" v-show="this.isLoading"></div> 
        </div>
    </vue-final-modal>
</template>

<script>

import OrderService from "@/services/order.service.js";
import OrderData from "@/models/OrderData.model.js";
import {risorseMixin} from "@/mixin.js";

export default { 
    name: "ModalSendOrder",
    data(){
        return {
            orderSuccess: false,
            showText: true,
            showOrderError: false,
            showOrderSuccess: false,
            isLoading: false,
            submitDisabled: false,
            orderErrorMsg: "",
            showModal: false
        }
    },
    props:{
        response: Number
    },
    mixins:[risorseMixin],
    methods:{
        closeModal: function(){
            if(this.orderSuccess){
                this.$router.push("/home");
            }
            else{
                this.$vfm.hide('example');
            }
        },
        submitOrder: function(){
            this.isLoading = true;
            let orderData = new OrderData(
                this.$parent.$parent.$data.noteOrdine,
                this.$store.getters.getCarrello.Testata.IdCarrello,
                this.$store.getters.getAnagraficaAzienda.CodiceCliente,
                this.$store.getters.getShippingAddress
            );
            OrderService.sendOrder(this.$store.getters.getToken, orderData).then(
                /** @type {OrderResponse} */
                (data) => {
                    this.isLoading = false;
                    this.showText = false;
                    if(data.Status === 1){
                        this.showOrderSuccess = true;
                        this.submitDisabled = true;
                        this.orderSuccess = true;
                        this.$store.commit("removeCart");
                        this.$store.commit("setSpSpedizione", 0);
                    }
                    else{
                        this.showOrderError = true;
                        this.orderErrorMsg = data.Message;
                    }
                },
                (error) => {
                    this.isLoading = false;
                    this.showOrderError = true;
                }
            )
            .catch(
                error => {
                    this.isLoading = false;
                    this.showOrderError = true;
                }
            );
        }
    },
    mounted: function(){
        this.orderErrorMsg = this.risorse["OrdineKoGen"];
    }
}
</script>
<style>
.modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
    width: 360px;
}

.imgCarrello{
    width: 100px;
    display: inline-block;
    margin: 0 auto 0 auto;
}

.textCarrello{
    padding: 20px 0 20px 0;
    text-align: center;
}

.btnContainer{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}

.btnCart{
    width: 100%;
    padding-left:0;
    padding-right:0;
    text-align: center;
}

.btnContinue{
    background: #101820 !important;
    color: #fff !important;
}

.textCarrello .textDanger{
    color: #ff0000;
}

.textCarrello .textSuccess{
    color: #00bb2d;
}
</style>